export default __webpack_public_path__ + "static/media/elk@2x.1447e30b.jpg";